"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const DRAFT_TOKEN = process.env.DRAFT_TOKEN;
const Typo3DraftModeHandler = async (req, res) => {
  const {
    secret,
    slug
  } = req.query;
  if (secret !== DRAFT_TOKEN || !slug) {
    return res.status(401).json({
      message: 'Invalid token'
    });
  }
  res.setDraftMode({
    enable: true
  });
  res.redirect(slug);
};
var _default = Typo3DraftModeHandler;
exports.default = _default;